export default {"src":"/_next/static/image/public/images/flags/flag_686.1dfeeee96c60952e3d6203bcb2187ce3.svg","height":16,"width":24};